import {Injectable} from '@angular/core';
import {HttpService} from '@app/core/services/http.service';
import {AuthService} from '@app/core/services/auth.service';
import {BaseService} from '@app/core/services/base.service';
import {InternationalizationService} from '@app/core/services/internationalization.service';
import {SupplementalSalary} from '@app/core/models/supplementalSalary.model';
import {Store} from '@ngrx/store';
import {IAppState} from '@app/core/store/state/app.state';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {Pagination, PaginationHolder} from '@app/core/models/pagination.model';

export interface ISupplementalSalaryFilter {
	'filter[users.id]'?: number;
	'filter[groups.id]'?: number | string;
	'include'?: string;
	'sort'?: string;
	'filter[auto_add_new_users]'?: number;
}

@Injectable({
	providedIn: 'root',
})

export class SupplementalSalaryService extends BaseService {
	constructor(
		public authService: AuthService,
		public interService: InternationalizationService,
		public httpService: HttpService,
		public store: Store<IAppState>,
	) {
		super(authService, interService, httpService, store);
	}

	public fresh(params?): SupplementalSalary {
		if (!params) {
			return new SupplementalSalary(this.tenantTZ, this.interService);
		}

		return new SupplementalSalary(this.tenantTZ, this.interService).deserialize(params);
	}

	public getSupplementalSalaries(page: number, page_size: number, filters): Observable<PaginationHolder<SupplementalSalary>> {
		const params = {
			page,
			page_size,
			...filters,
		};

		return this.httpService.getJson<PaginationHolder<SupplementalSalary>>('supplementalSalaries', params)
			.pipe(map((res: PaginationHolder<SupplementalSalary>) => {
				res.data = res.data.map(data => this.fresh(data));
				res.pagination = new Pagination().deserialize(res.pagination);

				return res;
			}));
	}

	public getSupplementalSalary(id: number): Observable<SupplementalSalary> {
		const data = {
			include: 'groups,group_users',
		};

		return this.httpService.getJson<SupplementalSalary>('supplementalSalaries/' + id, data)
			.pipe(map((res: SupplementalSalary) =>
				this.fresh(res)));
	}

	public postSupplementalSalary(payload: {}): Observable<SupplementalSalary> {
		return this.httpService.postJson<SupplementalSalary>('supplementalSalaries', payload).pipe(map(supplement => this.fresh(supplement)));
	}

	public patchSupplementalSalary(id: number, payload: {}): Observable<SupplementalSalary> {
		return this.httpService.patchJson<SupplementalSalary>('supplementalSalaries/' + id, payload).pipe(map(supplement => this.fresh(supplement)));
	}

	public deleteSupplementalSalary(id: number): Observable<SupplementalSalary> {
		return this.httpService.deleteJson<SupplementalSalary>('supplementalSalaries/' + id).pipe(map(supplement => this.fresh(supplement)));
	}
}
